import React from "react";
import { Group, Text, Box } from '@mantine/core';
import { Carousel } from '@mantine/carousel';

import { ROOT_BASE_URL } from "../../utils/globalVariables";

import InputWrapperCustom from "../general/InputWrapperCustom";

const BarangProjectNotaFotoDibatalkan = ({ stateData, fnClickPhoto }) => {

    const heightImage = 120;

    return (
        <React.Fragment>
            <InputWrapperCustom
                stateLabel={
                    <Group spacing={6}>
                        <Text>{stateData.data.label}</Text>
                        <Text>({Array.isArray(stateData.data.value) ? stateData.data.value.length : 0})</Text>
                    </Group>
                }
                stateWithAsterisk={stateData.data.withAsterisk}
                stateError={stateData.data.error}
                stateDescription={stateData.data.description}
            >
                {Array.isArray(stateData.data.value) && stateData.data.value.length > 0 &&
                    <Carousel
                        withIndicators={false}
                        withControls={Array.isArray(stateData.data.value) && (stateData.data.value.length > 1)}
                        height={heightImage}
                        slideSize="33.333333%"
                        slideGap="xs"
                        loop
                        align="start"
                        mt='md'
                    >
                        {Array.isArray(stateData.data.value) && Object.keys(stateData.data.value).map((keyFB, index) => {
                            return (
                                <Carousel.Slide key={keyFB}>
                                    <Box
                                        sx={{
                                            position: 'relative',
                                            height: heightImage + 'px'
                                        }}
                                    >
                                        <img
                                            alt={`foto-barang-${index}`}
                                            src={`${ROOT_BASE_URL}${stateData.data.value[keyFB].foto_barang_nota_name}`}
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'cover'
                                            }}

                                            onClick={() => fnClickPhoto({
                                                images: stateData.data.value,
                                                title: 'Foto Barang',
                                                index: Number(keyFB),
                                                fieldName: 'foto_barang_nota_name',
                                                show: true,
                                            })}
                                        />

                                        <Box
                                            px='.5rem'
                                            sx={(tema) => ({
                                                height: '30px',
                                                backgroundColor: tema.fn.rgba('#404040', 0.75),
                                                position: 'absolute',
                                                bottom: 0,
                                                left: 0,
                                                right: 0,
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                            })}
                                        >
                                            <Text color="#fff"> {String(Number(keyFB) + 1)}</Text>
                                        </Box>
                                    </Box>
                                </Carousel.Slide>
                            )
                        })}
                    </Carousel>
                }
            </InputWrapperCustom>
        </React.Fragment>
    )
}

export default BarangProjectNotaFotoDibatalkan;